import module from './module';

import ExternalStoreHandler from './controllers/ExternalStoreHandler';
import ApplicationController from './controllers/ApplicationController';
import ConfirmTicketController from './controllers/ConfirmTicketController';
import ChangePasswordController from './controllers/ChangePasswordController';
import LoginController from './controllers/LoginController';
import LoginTicketController from './controllers/LoginTicketController';
import CategoryHeaderDirective from './directives/CategoryHeaderDirective';
import FocusMeDirective from './directives/FocusMeDirective';
import FooterDirective from './directives/FooterDirective';
import HeaderDirective from './directives/HeaderDirective';
import LoadingIndicatorDirective from './directives/LoadingIndicatorDirective';
import InputCompareToDirective from './directives/InputCompareToDirective';
import InputElementErrorDirective from './directives/InputElementErrorDirective';
import InputFocusDirective from './directives/InputFocusDirective';
import PayPalPaymentForm from './directives/PayPalPaymentForm';
import SquareUpPaymentForm from './directives/SquareUpPaymentForm';
import StickyPanelDirective from './directives/StickyPanelDirective';
import WidthChangedHandlerDirective from './directives/WidthChangedHandlerDirective';
import InviteLinkDirectiveController from './directives/InviteLinkDirective';
import AuthenticationService from './services/AuthenticationService';
import AuthInterceptorService from './services/AuthInterceptorService';
import CartService from './services/CartService';
import CheckoutService from './services/CheckoutService';
import ConfigurationService from './services/ConfigurationService';
import ContactsService from './services/ContactsService';
import GroupOrderService from './services/GroupOrderService';
import MessageService from './services/MessageService';
import OrderSetupService from './services/OrderSetupService';
import RealTimeUpdateService from './services/RealTimeUpdateService';
import SessionService from './services/SessionService';
import SessionStorageService from './services/SessionStorageService';
import LocalForageService from './services/storageService';
import UserProfileService from './services/UserProfileService';
import HeapService from './services/HeapService';
import MoneyDirective from './directives/MoneyDirective';
import markDownTranslpileDirective from './directives/markdownTranspileDirective';
import CommonConstants from "../../utils/CommonConstants";
import {textOnHover} from "./directives/TextOnHoverDirective";
import CartonomyLogo from './directives/CartonomyLogoDirective';

module.controller('ApplicationController', ApplicationController);

module.directive(markDownTranslpileDirective.directiveName, markDownTranslpileDirective);

module.run([
    '$window',
    '$state',
    'LocalForageService',
    '$rootScope',
    'CartService',
    function (windowService, $state, localForageService, $rootScope, CartService) {
        windowService.onbeforeunload = ($event) => {

            const context = {
                preventReloadMessage: null,
                preventReload: false
            };

            $rootScope.$broadcast(CommonConstants.Events.ON_WINDOW_UNLOADING, context);

            if(context.preventReload)
                return context.preventReloadMessage;

            return;
        };
    }
]);


module.directive('textOnHover', textOnHover);

module
    .filter('ellipsisText', [
        function () {
            return function (input, trimLength, trimHtml) {
                if (!trimLength) {
                    trimLength = 20;
                }

                if (!input) return '';

                if (trimHtml) {
                    input = input.replace(/<(?:.|\n)*?>/gm, '');
                }

                var output = input.substr(0, trimLength);
                var s = output + (input.length > trimLength - 3 ? '...' : '');

                return s;
            }
        }
    ]);

export default module.name;



// WEBPACK FOOTER //
// ./src/modules/shared/index.js